// client/src/modules/new-year-tree/product.ts
import { TreePine } from 'lucide-react';

import { defineColoringProduct } from '../../shared/coloring-kit/product';
import type { StatusTexts } from '../../shared/coloring-kit/status/StatusScreen';

import { treeApi } from './api';
import { TOY_KINDS, TOY_LABELS } from './scene/art';
import { treePaths, type TreeWork, type TreeWorld } from './types';

/** Новогодняя ёлка как продукт на общем ките: всё, что кит должен знать о ней, собрано здесь. */
export const treeProduct = defineColoringProduct<TreeWorld, TreeWork>({
  slug: 'new-year-tree',
  api: treeApi,
  paths: treePaths,
  brand: { name: 'Новогодняя ёлка', tagline: 'Рисунки становятся игрушками', Icon: TreePine, bootTheme: 'winter' },
  kinds: TOY_KINDS.map((id) => ({ id, label: TOY_LABELS[id] })),
});

export const TREE_STATUS_TEXTS: StatusTexts = {
  openFailedTitle: 'Не удалось открыть ёлку',
  unavailableEyebrow: 'Ёлка пока недоступна',
  addBlockedEyebrow: 'Игрушку сейчас не добавить',
};
